import React, { useState,useRef,useEffect } from 'react';
import DatePicker from "react-datepicker";
import { Card, Toast } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Modal, Button } from 'react-bootstrap';
import { ReactTabulator } from 'react-tabulator';
import { useLocation, Link } from 'react-router-dom';
import basicUser from '../../assets/img/basic_user.jpg'
import "react-datepicker/dist/react-datepicker.css";
import "tabulator-tables/dist/css/tabulator_semanticui.min.css"; 
import loader from '../../assets/img/loading.gif'
import API from '../../api/api.jsx';
import CustomToast from '../../components/toast/toast.jsx';
import { MEDIA_BASE_URL } from '../../config/app-axios.jsx';

//아코디언 분리
import Loan002_01 from './loan_002_01.jsx';
import Loan002_02 from './loan_002_02.jsx';
import Loan002_03 from './loan_002_03.jsx';
import Loan002_04 from './loan_002_04.jsx';
import Loan_002_05 from './loan_002_05.jsx'
import moment from 'moment';

const mediaUrl = MEDIA_BASE_URL;

const customCardBodyStyle = {
	margin       : 'auto',
    display      : 'block',
    maxWidth     : '100%',
    width        : '100%',
    borderRadius : '0.375rem', // 같은 의미의 rounded-md    
    alignItems   : 'center', // items-center
	marginBottom : '7px',
};

// 베트남 동 통화로 변환하는 함수
function formatMoney(amount) {
	return new Intl.NumberFormat('vi-VN', {
		style    : 'currency',
		currency : 'VND',
	}).format(amount).replace(/[₫]/g,'').trim(); // 통화 기호만 제거
};

// 쉼표 등을 제거한 후 숫자로 변환
const convertToNumber = (value) => {
	const intValue = value.replace(/\./g,'').replace(/[^\d]/g,'');
	return intValue
};

//기타,가족,관리영업직원 정보 칸  
const fixedTabSizeStyle = {        
    height: '300px',
};

// Tabulator columns 목록
const userColums = (t) => {
	return [	
		{formatter:"rowSelection", titleFormatter:"rowSelection", headerHozAlign: 'center', hozAlign:"center", headerSort:false, width:30, cellClick:function(e, cell){
			cell.getRow().toggleSelect();
		}},
		{ title: t('LOAN_APPLICATION.성명', { defaultValue: '성명' }), field: 'name', headerHozAlign: 'center', hozAlign: 'center', width:120 },		
		{ title: t('LOAN_APPLICATION.전화번호', { defaultValue: '전화번호' }), field: 'phone_number', headerHozAlign: 'center', hozAlign: 'center', width: 150 },
		{ title: t('LOAN_APPLICATION.주민번호', { defaultValue: '주민번호' }), field: 'id_card_number', headerHozAlign: 'center', hozAlign: 'center', width:160, },
		{ field: 'customer_id',visible:false },
	];
};

// 대출신청 화면
const Loan002_standalone = () => {
	// URL에서 파람 가져오기
	const location                        = useLocation();	
	const params                          = new URLSearchParams(location.search);
	const loanApplicationId               = params.get('loanApplicationId');

	// 번역
	const { t, i18n } 		              = useTranslation();

	//토스트
	const [toast, setToast]               = useState(false);
	const [text]                 		  = useState(t('LOAN_APPLICATION.고객정보가 등록되었습니다', { defaultValue: '고객정보가 등록되었습니다' }));

	// 기타 상태 및 모달
	const [loading, setLoading]           = useState(false);	//로딩
	const [showModal, setShowModal]       = useState(false); 	//고객조회 모달
	const [appshowModal, setAppShowModal] = useState(false); 	//고객조회 모달

	// Tabulator 관련
	const tableRef    				      = useRef(null);
	const [columns, setColumns]           = useState(userColums(t));

	//링크를 타고 들어올때 그 대출의 상태 S01/S02/S03
	const [loan_status, setLoanStatus]    = useState('');

	const [hovered1, setHovered1] 	      = useState(false);  // 버튼 호버
	const [hovered2, setHovered2] 	      = useState(false);  // 버튼 호버
	const [buttonText, setButtonText]     = useState('고객정보 저장');
	const [activeTab, setActiveTab]       = useState('nav-pills-tab-1');

	//고객정보 입력란 기본값 disabled : True
	const [isDisabled, setIsDisabled]     = useState(true); // 기본값은 true로 설정 input에 disabled 기본값	

	//고객조회 data 기본값
	const [responseData, setResponseData]           = useState([]);
	const [staffEmail, setStaffEmail]               = useState('');
	const [responseStaffData, setResponseStaffData] = useState([]);

	//대출 정보 selectBox 기본값
	const [SelectOptions1,setSelectOptions1]  = useState([]);
	const [SelectOptions2,setSelectOptions2]  = useState([]);
	const [SelectOptions3,setSelectOptions3]  = useState([]);
	const [SelectOptions4,setSelectOptions4]  = useState([]);
	const [SelectOptions5,setSelectOptions5]  = useState([]);

	//날짜 기본값
	const defaultDate 				= new Date();
	const defaultYear               = defaultDate.getFullYear();
	const [startDate, setStartDate] = useState(defaultDate.setMonth(defaultDate.getMonth()));

	// DatePicker Custom 준비물 ①
	function range(start, end, step) {
		const result = [];
		for (let i = start; i < end; i += step) {
			result.push(i);
		}
		return result;
	};

	// DatePicker Custom 준비물 ②
	const years  = range(1900, defaultYear + 1, 1);
	const months = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];

	//고객 정보 추가/수정 기본값	    	
	const [customer_id, setCustomer_id]   	                 = useState(''); //고객ID
	const [loan_application_id, setinputLoan_application_id] = useState(''); //대출ID	
	const [name, setName]                 	                 = useState(''); // 이름
	const [phone_number, setPhonenumber]  	                 = useState(''); // 전화번호
	const [id_card_number, setIdCardNumber]                  = useState(''); // 주민번호
	const [user_file, setUser_file]                          = useState([]); // 유저이미지
	const [imageUrl, setImageUrl] 							 = useState('');


	//기타정보
	const [birth_date, setIdBirDate] 	  						            = useState(defaultDate); // 생년월일
	const [address, setAddress]             					            = useState(''); // 거주지
	const [resident_reg_issue_date, setResident_reg_issue_date]             = useState(defaultDate); // 주민등록발급일
	const [resident_reg_issue_place, setResident_reg_issue_place]           = useState(''); // 주민등록발행지
	const [occupation, setOccupation]       					            = useState(''); // 직업
	const [company_name, setCompany_name]       				            = useState(''); // 회사명
	const [monthly_income, setMonthly_income]       			            = useState(''); // 소득(월)
	const [concerned_person_name, setConcerned_person_name]                 = useState(''); // 관계인
	const [concerned_person_phone_number, setConcerned_person_phone_number] = useState(''); // 관계인전화번호
	const [email, setIdEmail] 			  							        = useState(''); // 이메일
	const [residence_place, setResidence_place] 					        = useState(''); // 주소지
	const [remark, setRemark] 			  							        = useState(''); // 적요

	//가족정보
	const [spouse_name, setSpouse_name] 			  	= useState(''); // 배우자 성명
	const [spouse_occupation, setSpouse_occupation] 	= useState(''); // 배우자 직업
	const [spouse_phone_number, setSpouse_phone_number] = useState(''); // 배우자 전화번호
	const [mother_name, setMother_name] 			  	= useState(''); // 어머니 성명
	const [mother_occupation, setMother_occupation] 	= useState(''); // 어머니 직업
	const [mother_phone_number, setMother_phone_number] = useState(''); // 어머니 전화번호
	const [father_name, setFather_name] 			  	= useState(''); // 아버지 성명
	const [father_occupation, setFather_occupation] 	= useState(''); // 아버지 직업
	const [father_phone_number, setFather_phone_number] = useState(''); // 아버지 전화번호
	const [etc, setEtc] 								= useState(''); // 기타정보
	
	const fileInputRef 						            = useRef(null);
	const standaloneWindow = window; // 자기 자신 창 참조

	//고객이미지
	const profileBoxStyle = {
		width: '200px',
		height: '200px',
		border: '1px solid #ffffff',    // 테두리 스타일 및 색상 지정
		padding: '10px',               // 내부 여백 설정
		backgroundImage: `url(${imageUrl || basicUser})`,
		backgroundSize: '100% 100%',
		cursor: 'pointer', // 마우스 커서를 포인터로 변경
	};

	// 2023-12-19 (추가 : 정영진)
	// 대출신청 상태에 따른 심사요청 기능 막기
	const childComponent = useRef(null);

	// 모달창오픈
	const handleAppModalOpen = async () => {
		// 대출 신청 상태를 확인하여 접수중이 아닌 경우에는 심사요청 기능을 막는다.		
		if (childComponent.current) {
			const childData = childComponent.current.getChildData();

			if (!(loan_application_id || loanApplicationId)) {
				alert('대출 정보를 저장한 이후 심사요청이 가능합니다.');
				return;
			};

			let use_loan_application_id;

			if (loanApplicationId || loan_application_id) {
				use_loan_application_id = loanApplicationId || loan_application_id;
			}

			try {
				const response = await API.fetchloan002CheckData({ 
					use_loan_application_id
				});		
				
				// 현재 날짜 가져오기
				const currentDate       = new Date();
				
				// 각 날짜의 연, 월, 일을 가져옴
				const year          = currentDate.getFullYear();
				const month         = String(currentDate.getMonth() + 1).padStart(2, '0');  // 월을 2자리로 표시하고자 함
				const day           = String(currentDate.getDate()).padStart(2, '0');  // 일을 2자리로 표시하고자 함				
				const formattedDate = `${year}-${month}-${day}`;
				let success         = response[0].success
				let execution_type  = response[0].execution_type
				let loan_date       = response[0].loan_date
				
				// 수수료 또는 담보물에 저장 값이 없을 경우
				if(success === 'false'){
					alert(t(`COMMON.수수료 또는 담보물 등록은 필수입니다.`, { defaultValue: '수수료 또는 담보물 등록은 필수입니다.' }));
					return;
				}else if(loan_date < formattedDate && execution_type === "T01"){
						//대출실행타입이 자동일때 대출예정일이 오늘날짜 이전일 경우 기능을 막는다.
						alert('대출예정일을 확인해주세요.');
						return
					}

			} catch (error) {
				console.error('Error in fetchReport005DataUpdateState:', error);
			}

			if (childData && childData === 'S04' || childData === 'S06') {
				let result = window.confirm('거절된 내역입니다. 다시 결재하시겠습니까?');

				if (result) {
					setAppShowModal(true);
				} else {
					setAppShowModal(false);
				}
				
			} else if (childData && childData !== 'S01') {
				alert('이미 심사중인 내역입니다.');
				setAppShowModal(false);
				return;
			}else{
				setAppShowModal(true);
			};
		};
	};

	//대출 ID 변경
	const setLoan_application_id = (value) =>{		
		setinputLoan_application_id(value)		
	};

	// 관리영업직원
	const handleChangeStaff = (e) => {
		setStaffEmail(e);
	};

	// 고객ID 변경
	const handleChangeCustomer_id = (e) => {
		setCustomer_id(e.target.value);
	};

	//성명
	const handleChangeName = (e) => {
		setName(e.target.value);
	};

	//전화번호
	const handleChangePhoneNumber = (e) => {
		setPhonenumber(e.target.value);
	};

	//주민번호
	const handleChangeIdCardNumber = (e) => {
		setIdCardNumber(e.target.value);
	};

	//생년월일
	const handleChangeBirthDate = (date) => {
		setIdBirDate(date);		
	};

	//거주지
	const handleChangeAddress = (e) => {
		setAddress(e.target.value);
	};

	//주민등록발급일
	const handleChangeResidentRegIssueDate = (date) => {
		setResident_reg_issue_date(date);
	};

	//주민등록발급지
	const handleChangeResidentRegIssuePlace = (e) => {
		setResident_reg_issue_place(e.target.value);
	};

	//직업
	const handleChangeOccupation = (e) => {
		setOccupation(e.target.value);
	};

	//회사명
	const handleChangeCompanyName = (e) => {
		setCompany_name(e.target.value);
	};

	//소득(월)
	const handleChangeMonthlyIncome = (e) => {
		const numericValue = e.target.value.replace(/\D/g,'').trim();	
		setMonthly_income(formatMoney(Number(numericValue)));
	};

	// 관계인
	const handleChangeConcernedPersonName = (e) => {
		setConcerned_person_name(e.target.value);
	};

	// 관계인전화번호
	const handleChangeConcernedPersonPhoneNumber = (e) => {
		setConcerned_person_phone_number(e.target.value);
	};

	// Email
	const handleChangeEmail = (e) => {
		setIdEmail(e.target.value);
	};

	//주소지
	const handleChangeResidencePlace = (e) => {
		setResidence_place(e.target.value);
	};

	//적요
	const handleChangeRemark = (e) => {
		setRemark(e.target.value);
	};

	// 배우자 성명
	const handleSetSpouseName = (e) => {
		setSpouse_name(e.target.value);
	};

	// 배우자 직업
	const handleSetSpouseOccupation = (e) => {
		setSpouse_occupation(e.target.value);
	};

	// 배우자 전화번호
	const handleSetSpousePhoneNumber = (e) => {
		setSpouse_phone_number(e.target.value);
	};

	// 어머니성명
	const handleSetMotherName = (e) => {
		setMother_name(e.target.value);
	};

	// 어머니직업
	const handleSetMotherOccupation = (e) => {
		setMother_occupation(e.target.value);
	};

	//어머니 전화번호
	const handleSetMotherPhoneNumber = (e) => {
		setMother_phone_number(e.target.value);
	};

	// 아버지 성명
	const handleSetFatherName = (e) => {
		setFather_name(e.target.value);
	};

	// 아버지 직업
	const handleSetFatherOccupation = (e) => {
		setFather_occupation(e.target.value);
	};

	// 아버지 전화번호
	const handleSetFatherPhoneNumber = (e) => {
		setFather_phone_number(e.target.value);
	};

	// 기타정보
	const handleSetEtc = (e) => {
		setEtc(e.target.value);
	};

	//고객정보저장
	const handleSave = async (e) => {   

		//필수값 
		if(phone_number === '' || id_card_number === '' || name === '' || birth_date ==='' || address ==='' || resident_reg_issue_date ==='' || resident_reg_issue_place ==='' || occupation ==='' || residence_place ===''){
			alert(t(`COMMON.필수 입력 사항이 입력되지 않았습니다.`, { defaultValue: '필수 입력 사항이 입력되지 않았습니다.' }))
			return
		}		

		try {		
		const formData = new FormData();

			formData.append('file', user_file);
			formData.append('customer_id',customer_id);
			formData.append('name',name);
			formData.append('phone_number',phone_number);
			formData.append('id_card_number',id_card_number);
			// formData.append('birth_date',birth_date);
			formData.append('birth_date', moment(birth_date).format('YYYY-MM-DD'));
			formData.append('address',address);
			// formData.append('resident_reg_issue_date',resident_reg_issue_date);
			formData.append('resident_reg_issue_date',moment(resident_reg_issue_date).format('YYYY-MM-DD'));
			formData.append('resident_reg_issue_place',resident_reg_issue_place);
			formData.append('occupation',occupation);
			formData.append('company_name',company_name);
			formData.append('monthly_income',convertToNumber(monthly_income));
			formData.append('concerned_person_name',concerned_person_name);
			formData.append('concerned_person_phone_number',concerned_person_phone_number);
			formData.append('email',email);
			formData.append('residence_place',residence_place);
			formData.append('remark',remark);
			formData.append('spouse_name',spouse_name);
			formData.append('spouse_occupation',spouse_occupation);
			formData.append('spouse_phone_number',spouse_phone_number);
			formData.append('mother_name',mother_name);
			formData.append('mother_occupation',mother_occupation);
			formData.append('mother_phone_number',mother_phone_number);
			formData.append('father_name',father_name);
			formData.append('father_occupation',father_occupation);
			formData.append('father_phone_number',father_phone_number);
			formData.append('etc',etc);			

			const savedData = await API.fetchLoan002POSTData({				
				formData
			});

			setToast(true);
			setCustomer_id(savedData['customer_id'])
			setButtonText('고객정보 수정')

			if (savedData.code === 201) {
				console.log('고객 정보 저장 완료:', savedData);	
				alert('수수료 정보 저장 완료');
				handleClose();
			}
		}catch (error) {
				console.error('고객 정보 저장 에러:', error);
		}    
	};

	//모달
	const handleClose = () => setShowModal(false);		//모달버튼

	// 모달창닫고, 재조회 
	const handleAppClose = () => {		
		setAppShowModal(false);
	}

	const handleShow = () => {					//모달 보여주는 액션
		let count = 3
        if (name.length === 0) {
            //alert(t(`LOAN_APPLICATION.고객 이름을 입력하세요`, { defaultValue: '고객 이름을 입력하세요' }))
            count = count - 1
            //return;
        }
        if (phone_number.length < 9) {
            //alert(t(`LOAN_APPLICATION.고객 전화번호을 입력하세요`, { defaultValue: '고객 전화번호을 입력하세요' }))
            count = count - 1
            //return;
        }
        if (id_card_number.length !== 12) {
            //alert(t(`LOAN_APPLICATION.고객 주민번호를 확인하세요`, { defaultValue: '고객 주민번호를 확인하세요' }))
            count = count - 1
            //return;
        }
		if (count > 0) {

        } else {
            alert(t(`LOAN_APPLICATION.값을 입력하세요`, { defaultValue: '값을 입력하세요' }))
			setIsDisabled(true);	//disabled 만약 해제 되어있을경우를 대비
            return;
        }
		setColumns(userColums(t))
		//위 조건이 통과하였을 경우 API 실행
		const fetchLoan002UserModalData = async () => {
			try {
				const data = await API.fetchLoan002UserModalData({
					'name' 			: name,
					'phoneNumber' 	: phone_number,
					'idCardNumber' 	: id_card_number
				});											
			
				if(data.length !== 0) {
					setShowModal(true);										//모달open		
					setResponseData(data);
					return
				} else {						
					if(name.length > 0 && phone_number.length >= 9 && id_card_number.length === 12){					//값은 없는데 입력값은 전부 있을 때
						//disabled를 전부 풀고 등록이라고 alret창을 띄움
						alert(t(`LOAN_APPLICATION.검색결과가 없어 고객등록을 시작합니다`, { defaultValue: '검색결과가 없어 고객등록을 시작합니다' }));
						setIsDisabled(false); 								// 현재 값과 반대로 변경
					}else{//
						alert(t(`LOAN_APPLICATION.고객정보가 없습니다`, { defaultValue: '고객정보가 없습니다' }));
						return;				
					}
				}			
				
			} catch (error) {
				console.error('Error fetching UserModal data:', error);
			}
		};

		fetchLoan002UserModalData();				
	}
	
	//고객조회 모달에서 선택 액션
	const handleSelectClick = () => {
		const selectedData = tableRef.current.getSelectedData(); // 선택한 데이터 가져오기

		if (selectedData.length === 0) {
			// 선택한 데이터가 없는 경우
			alert('선택된 값이 없습니다.');
		} else {
			//customerID를 api로 쏘고 유저 data 를 가져옴			
			//유저 customer_id를 받아서 userDATA를 뱉음
			const fetchLoan002UserModalSelectData = async (customer_id) => {
				try {
					const data = await API.fetchLoan002UserModalSelectData({
						'customer_id' : customer_id,
					});	
					
					//date로 형변환
					const birthDate            = new Date(data[0]['birth_date'])
					const residentregissuedate = new Date(data[0]['resident_reg_issue_date'])

					setIsDisabled(false);	//input disabled 전부 해제					
					//userDATA를 input값에 넣는다.					
					//기본정보
					setCustomer_id(data[0]['customer_id'])
					setName(data[0]['name'])
					setPhonenumber(data[0]['phone_number'])
					setIdCardNumber(data[0]['id_card_number'])
					setIdBirDate(birthDate)
					setAddress(data[0]['address'])
					setResident_reg_issue_date(residentregissuedate)
					setResident_reg_issue_place(data[0]['resident_reg_issue_place'])
					setOccupation(data[0]['occupation'])
					setCompany_name(data[0]['company_name'])
					// setMonthly_income(data[0]['monthly_income'])
					setMonthly_income(formatMoney(Number(data[0]['monthly_income'])))
					setConcerned_person_name(data[0]['concerned_person_name'])
					setConcerned_person_phone_number(data[0]['concerned_person_phone_number'])
					setIdEmail(data[0]['email'])
					setResidence_place(data[0]['residence_place'])
					setRemark(data[0]['remark'])
					//가족정보
					setSpouse_name(data[0]['spouse_name'])
					setSpouse_occupation(data[0]['spouse_occupation'])
					setSpouse_phone_number(data[0]['spouse_phone_number'])
					setMother_name(data[0]['mother_name'])
					setMother_occupation(data[0]['mother_occupation'])
					setMother_phone_number(data[0]['mother_phone_number'])
					setFather_name(data[0]['father_name'])
					setFather_occupation(data[0]['father_occupation'])
					setFather_phone_number(data[0]['father_phone_number'])
					setEtc(data[0]['etc'])

					setButtonText('고객정보 수정')

					//이미지가 있을 때만 호출
					if(data[1]){
						const file_path = data[1]['file_path'];
						const updatedImageSrc = file_path !== '' ? `${mediaUrl}${file_path}` : '';
						setImageUrl(updatedImageSrc);
					}					

					setShowModal(false);

				} catch (error) {
					console.error('Error fetching UserModal data:', error);
				}
			};

			fetchLoan002UserModalSelectData(selectedData[0].customer_id);
		}
	};

	//마우스 올리면 색 변하는 액션
	const handleMouseEnterUserSelect = () => {
        setHovered1(true);
    };
    const handleMouseLeaveUserSelect = () => {
        setHovered1(false);
    };

	const handleMouseEnterUserSave = () => {
        setHovered2(true);
    };
    const handleMouseLeaveUserSave = () => {
        setHovered2(false);
    };
	const buttonStyleUserSelect = {
        backgroundColor: hovered1 ? '#286A45' : '#7DA390',
        color: '#FFFFFF', // 글자 색상
        /* 기타 스타일들... */
    };
	const buttonStyleUserSave = {
        backgroundColor: hovered2 ? '#286A45' : '#7DA390',
        color: '#FFFFFF', // 글자 색상
        /* 기타 스타일들... */
    };

	useEffect(() => {
		const fetchLoan002UserModalSelectData = async (loanApplicationId) => {
			try {
				const data = await API.fetchLoan002UserModalSelectData({
					'loanApplicationId' : loanApplicationId,
				});	
				window.name = "loan_002_standalone";  // 창 이름 지정

				//date로 형변환
				const birthDate            = new Date(data[0]['birth_date'])
				const residentregissuedate = new Date(data[0]['resident_reg_issue_date'])

				setIsDisabled(false);	//input disabled 전부 해제					
				//userDATA를 input값에 넣는다.					
				//기본정보
				setCustomer_id(data[0]['customer_id'])
				setName(data[0]['name'])
				setPhonenumber(data[0]['phone_number'])
				setIdCardNumber(data[0]['id_card_number'])
				setIdBirDate(birthDate)
				setAddress(data[0]['address'])
				setResident_reg_issue_date(residentregissuedate)
				setResident_reg_issue_place(data[0]['resident_reg_issue_place'])
				setOccupation(data[0]['occupation'])
				setCompany_name(data[0]['company_name'])
				setMonthly_income(formatMoney(Number(data[0]['monthly_income'])))
				
				setConcerned_person_name(data[0]['concerned_person_name'])
				setConcerned_person_phone_number(data[0]['concerned_person_phone_number'])
				setIdEmail(data[0]['email'])
				setResidence_place(data[0]['residence_place'])
				setRemark(data[0]['remark'])
				//가족정보
				setSpouse_name(data[0]['spouse_name'])
				setSpouse_occupation(data[0]['spouse_occupation'])
				setSpouse_phone_number(data[0]['spouse_phone_number'])
				setMother_name(data[0]['mother_name'])
				setMother_occupation(data[0]['mother_occupation'])
				setMother_phone_number(data[0]['mother_phone_number'])
				setFather_name(data[0]['father_name'])
				setFather_occupation(data[0]['father_occupation'])
				setFather_phone_number(data[0]['father_phone_number'])
				setEtc(data[0]['etc'])
				setButtonText('고객정보 수정')

				//대출 상태
				setLoanStatus(data[0]['status'])
				
				//이미지가 있을 때만 호출
				if(data[1]){
					const file_path = data[1]['file_path'];
					const updatedImageSrc = file_path !== '' ? `${mediaUrl}${file_path}` : '';
					setImageUrl(updatedImageSrc)
				}
				
				setShowModal(false);	//모달창 닫기
									
			} catch (error) {
				console.error('Error fetching UserModal data:', error);
			}
		};

		if (loanApplicationId) {
			fetchLoan002UserModalSelectData(loanApplicationId)	
		}
	}, [loanApplicationId]);

	useEffect(() => {		
		const fetchBaseOptions = async () => {			
			try {
				const data = await API.fetchBaseOptions();
				
				const options1  = data.filter(item => item.code_nick_name === '상환방법');
				const SelectOptions1 = options1.map(item => [item.code,item.code_se]);
				
				setSelectOptions1(SelectOptions1);
				
				const options2 = data.filter(item => item.code_nick_name === '이자지급주기');
				const SelectOptions2 = options2.map(item => [item.code,item.code_se]);
				
				setSelectOptions2(SelectOptions2);
				
				const options3 = data.filter(item => item.code_nick_name === '이자');
				const SelectOptions3 = options3.map(item => [item.code,item.code_se]);
				
				setSelectOptions3(SelectOptions3);
				
				const options4 = data.filter(item => item.code_nick_name === '이자지급시기');
				const SelectOptions4 = options4.map(item => [item.code, item.code_se]);
				setSelectOptions4(SelectOptions4);
				
				const options5 = data.filter(item => item.code_nick_name === '이자');
				const SelectOptions5 = options5.map(item => [item.code, item.code_se]);
				setSelectOptions5(SelectOptions5);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};

		const fetchLoan002StaffData = async () => {
            try {
                const data = await API.fetchLoan002StaffData();
				// console.log(data)
                setResponseStaffData(data);
            } catch (error) {
                console.error('Error in fetchSanc00201Data Error:', error);
            }
        };
		
		fetchBaseOptions();
		fetchLoan002StaffData();	
	}, []); // 빈 배열은 컴포넌트가 마운트될 때 한 번만 실행

	const handleTabClick = (tabId) => {
		setActiveTab(tabId);
	};

	// 파일 변경 핸들러
	const handleImageChange = (event) => {
		// 이미지가 업로드되면 해당 로직을 수행하고, 이미지 URL을 state에 업데이트합니다.
		const selectedFile = event.target.files[0];
		const imageUrl     = URL.createObjectURL(selectedFile);
		const formData     = new FormData();

		formData.append(`file`,selectedFile)

		setUser_file(selectedFile); // 새로운 배열을 반환하여 상태를 업데이트
		setImageUrl(imageUrl);
	};

	// 화면 UI
	return (
		
		<Card style={{ height: '100%' }}>
			<Card.Header><strong>{t('LOAN_APPLICATION.대출신청', { defaultValue: '대출신청' })}  { loanApplicationId }</strong></Card.Header>
				<Card.Body className='responsive-card-body'>
				<div className="panel-body">
					<div className="row ms-0">	
						<Card.Body className='card' style={customCardBodyStyle}>
							{/* 성명 전화번호 주민번호 */}
							<div id="content">
								<div className="panel-body">
									<div className="row">
										<input type="text" className="form-control" value={customer_id} onChange={handleChangeCustomer_id} style={{ display: 'none' }}/>
										<input type="text" className="form-control" value={loan_application_id} style={{ display: 'none' }} readOnly />
										<div className="col-md-2">
											<div className="d-flex justify-content-center">
												<div id="profile-upload" style={{ backgroundImage: `url(${imageUrl ? encodeURI(imageUrl) : basicUser})` }}>
													<div className="hvr-profile-img">
														<input 
															type="file" 
															accept="image/*" 
															className="form-control" 
															onChange={handleImageChange}
														/>
													</div>
													<i className="fa fa-camera"></i>
												</div>
											</div>
										</div>
										{/* <div className="col-md-2">
											<div className="d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
												<button onClick={() => fileInputRef.current.click()} style={profileBoxStyle}></button>
												<input
													id="fileInput"
													type="file"
													style={{ display: 'none' }}
													ref={fileInputRef}
													onChange={handleFileChange}													
												/>												
											</div>
										</div> */}
										<div className="col-md-5">
											<div className="row mb-35px">
												<label className="form-label col-form-label col-md-3">{t('LOAN_APPLICATION.성명', { defaultValue: '성명' })}</label>
												<div className="align-middle col-md-9">
													<input id="nameInput" type="text" className="form-control" onChange={handleChangeName}  value={name} />
												</div>
											</div>
											<div className="row mb-35px">
													<label className="form-label col-form-label col-md-3" htmlFor="">{t('LOAN_APPLICATION.전화번호', { defaultValue: '전화번호' })}</label>
												<div className="col-md-9">
													<input id="phoneInput" type="text" className="form-control" placeholder="" onChange={handleChangePhoneNumber} value={phone_number}/>
												</div>
											</div>
											<div className="row ">
													<label className="form-label col-form-label col-md-3" htmlFor="">{t('LOAN_APPLICATION.주민번호', { defaultValue: '주민번호' })}</label>
												<div className="col-md-9">
													<input id="idCardNumber" type="text" className="form-control" placeholder="" maxLength={12} onChange={handleChangeIdCardNumber} value={id_card_number}/>
												</div>
											</div>
											{/* 나머지 input과 label 요소들 */}
										</div>
										<div className="col-md-2">
											<div className="mb-35px">
												<button type="button" className="btn text-white" style={buttonStyleUserSelect} onMouseEnter={handleMouseEnterUserSelect} onMouseLeave={handleMouseLeaveUserSelect} onClick={handleShow}>
													{t('LOAN_APPLICATION.고객조회', { defaultValue: '고객조회' })}
												</button>
											</div>																									
										</div>
										<div className="col-md-2"></div>
									</div>
								</div>		
								{/* 모달창 */}
								<Modal show={showModal} onHide={handleClose} centered>
									<Modal.Header closeButton>
									<Modal.Title>{t('LOAN_APPLICATION.고객조회', { defaultValue: '고객 조회' })}</Modal.Title>
									</Modal.Header>
									<Modal.Body>
									{/* 모달 내용 */}
									{/* Tabulator */}
									<ReactTabulator
										key={i18n.language  + JSON.stringify(columns)} // 이 부분을 추가하면 언어 변경 시마다 컴포넌트가 리렌더링됩니다.
										onRef={(r) => (tableRef.current = r.current)}
										columns={columns}
										data={responseData}
										options={{
											layout: "fitColumns",											
											selectable: 1, // 1은 단일 선택, 0은 다중 선택, false는 선택 비활성화
										}}
										className="responsive-tabulator"
									/>
									</Modal.Body>
									<Modal.Footer>
									<Button style={buttonStyleUserSelect} onMouseEnter={handleMouseEnterUserSelect} onMouseLeave={handleMouseLeaveUserSelect} onClick={handleSelectClick}>선택</Button>
									<Button variant="secondary" onClick={handleClose}>닫기</Button>
									</Modal.Footer>
								</Modal>
							</div>	
						</Card.Body>
						<Card.Body className='card' style={customCardBodyStyle}>
							{/* 기타정보 가족정보 관리영업직원정보 */}
							<div id="content" className="">
								<div className="panel-body">
									<ul className="nav nav-pills mb-2">
										<li className="nav-item">
											<a href="#nav-pills-tab-1" data-bs-toggle="tab" className={`nav-link ${activeTab === 'nav-pills-tab-1' ? 'active' : ''}`} 
											onClick={() => handleTabClick('nav-pills-tab-1')} style={activeTab === 'nav-pills-tab-1' ? { backgroundColor: '#7DA390' } : {}}>
												<span className="d-sm-block d-none">{t('LOAN_APPLICATION.기타정보', { defaultValue: '기타정보' })}</span>
											</a>
										</li>
										<li className="nav-item">
											<a href="#nav-pills-tab-2" data-bs-toggle="tab" className={`nav-link ${activeTab === 'nav-pills-tab-2' ? 'active' : ''}`} 
											onClick={() => handleTabClick('nav-pills-tab-2')} style={activeTab === 'nav-pills-tab-2' ? { backgroundColor: '#7DA390' } : {}}>
												<span className="d-sm-block d-none">{t('LOAN_APPLICATION.가족정보', { defaultValue: '가족정보' })}</span>
											</a>
										</li>
										<li className="nav-item">
											<a href="#nav-pills-tab-3" data-bs-toggle="tab" className={`nav-link ${activeTab === 'nav-pills-tab-3' ? 'active' : ''}`} 
											onClick={() => handleTabClick('nav-pills-tab-3')} style={activeTab === 'nav-pills-tab-3' ? { backgroundColor: '#7DA390' } : {}}>
												<span className="d-sm-block d-none">{t('LOAN_APPLICATION.관리영업직원정보', { defaultValue: '관리영업직원정보' })}</span>
											</a>
										</li>						
									</ul>				
									<div className="tab-content p-3 rounded-top panel rounded-0 m-0">
										<div className="tab-pane fade active show" id="nav-pills-tab-1" style={fixedTabSizeStyle}>
											<table className="table table-panel mb-0">							
												<tbody>
													<tr>
														<td style={{width : `15%`}} className="align-middle">{t('LOAN_APPLICATION.생년월일', { defaultValue: '생년월일' })} <span className="text-danger">*</span></td>
														<td style={{width : `35%`}}>
															<div className="input-group input-daterange">
																<div className='col'>
																	<DatePicker
																		renderCustomHeader={({
																			date,
																			changeYear,
																			changeMonth,
																			decreaseMonth,
																			increaseMonth,
																			prevMonthButtonDisabled,
																			nextMonthButtonDisabled,
																		}) => (
																			<div
																				style={{
																					margin         : 10,
																					display        : "flex",
																					justifyContent : "space-between",
																				}}
																			>
																				<button className='border-0 bg-none' onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
																					<i className="fa-solid fa-angle-left"></i>
																				</button>

																				{/* 월 */}
																				<select
																					className ='form-select-sm fw-bold'
																					value     = {months[date.getMonth()]}
																					onChange  = {({ target: { value } }) => changeMonth(months.indexOf(value))}
																				>
																					{months.map((option) => (
																						<option key={option} value={option}>
																							{option}
																						</option>
																					))}
																				</select>

																				{/* 연도 */}
																				<select
																					className ='form-select-sm fw-bold'
																					value     = {date.getFullYear()}
																					onChange  = {({ target: { value } }) => changeYear(value)}
																				>
																					{years.map((option) => (
																						<option key={option} value={option}>
																							{option}
																						</option>
																					))}
																				</select>

																				<button className='border-0 bg-none' onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
																					<i className="fa-solid fa-angle-right"></i>
																				</button>
																			</div>
																		)}
																		className='form-control w-50' 
																		selected={birth_date}
																		onChange={handleChangeBirthDate}
																		dateFormat="dd/MM/yyyy" 
																		showYearDropdown  // 연도 선택 드롭다운을 활성화합니다.
																		disabled={isDisabled} 
																	/>
																	<div className="input-group-prepend position-absolute top-0 end-50 bottom-0 d-flex">
																		<span className="input-group-text bg-none border-0">
																			<i className='far fa-calendar' />
																		</span>
																	</div>
																</div>														
															</div>														
														</td>
														<td className="align-middle">{t('LOAN_APPLICATION.거주지', { defaultValue: '거주지' })} <span className="text-danger">*</span></td>
														<td ><input id="add-sticky" className="form-control w-50" disabled={isDisabled} onChange={handleChangeAddress} value={address}/></td>
													</tr>
													<tr>
														<td className="align-middle">{t('LOAN_APPLICATION.주민등록발급일', { defaultValue: '주민등록발급일' })} <span className="text-danger">*</span></td>
														<td >
															<div className="input-group input-daterange">
																<div className='col'>
																	<DatePicker
																		renderCustomHeader={({
																			date,
																			changeYear,
																			changeMonth,
																			decreaseMonth,
																			increaseMonth,
																			prevMonthButtonDisabled,
																			nextMonthButtonDisabled,
																		}) => (
																			<div
																				style={{
																					margin         : 10,
																					display        : "flex",
																					justifyContent : "space-between",
																				}}
																			>
																				<button className='border-0 bg-none' onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
																					<i className="fa-solid fa-angle-left"></i>
																				</button>

																				{/* 월 */}
																				<select
																					className ='form-select-sm fw-bold'
																					value     = {months[date.getMonth()]}
																					onChange  = {({ target: { value } }) => changeMonth(months.indexOf(value))}
																				>
																					{months.map((option) => (
																						<option key={option} value={option}>
																							{option}
																						</option>
																					))}
																				</select>

																				{/* 연도 */}
																				<select
																					className ='form-select-sm fw-bold'
																					value     = {date.getFullYear()}
																					onChange  = {({ target: { value } }) => changeYear(value)}
																				>
																					{years.map((option) => (
																						<option key={option} value={option}>
																							{option}
																						</option>
																					))}
																				</select>

																				<button className='border-0 bg-none' onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
																					<i className="fa-solid fa-angle-right"></i>
																				</button>
																			</div>
																		)}
																		className='form-control w-50'
																		selected={resident_reg_issue_date}
																		// onChange={setResident_reg_issue_date}
																		onChange={handleChangeResidentRegIssueDate}
																		dateFormat="dd/MM/yyyy" 
																		disabled={isDisabled}
																	/>
																	<div className="input-group-prepend position-absolute top-0 end-50 bottom-0 d-flex">
																		<span className="input-group-text bg-none border-0">
																			<i className='far fa-calendar' />
																		</span>
																	</div>
																</div>														
															</div>
														</td>
														<td  className="align-middle">{t('LOAN_APPLICATION.주민등록 발급지', { defaultValue: '주민등록 발급지' })} <span className="text-danger">*</span></td>
														<td ><input className="form-control w-50" disabled={isDisabled} onChange={handleChangeResidentRegIssuePlace} value={resident_reg_issue_place}/></td>
													</tr>								
													<tr>
														<td  className="align-middle">{t('LOAN_APPLICATION.직업', { defaultValue: '직업' })} <span className="text-danger">*</span></td>
														<td ><input className="form-control w-50" disabled={isDisabled} onChange={handleChangeOccupation} value={occupation}/></td>
														<td  className="align-middle">{t('LOAN_APPLICATION.회사명', { defaultValue: '회사명' })}</td>
														<td ><input className="form-control w-50" disabled={isDisabled} onChange={handleChangeCompanyName} value={company_name}/></td>
													</tr>
													<tr>
														<td  className="align-middle">{t('LOAN_APPLICATION.소득(월)', { defaultValue: '소득(월)' })} <span className="text-danger">*</span></td>
														<td ><input className="form-control w-50 text-end" disabled={isDisabled} onChange={handleChangeMonthlyIncome} value={monthly_income} /></td>
														<td  className="align-middle">{t('LOAN_APPLICATION.관계인', { defaultValue: '관계인' })}</td>
														<td ><input className="form-control w-50" disabled={isDisabled} onChange={handleChangeConcernedPersonName} value={concerned_person_name}/></td>
													</tr>
													<tr>
														<td  className="align-middle">{t('LOAN_APPLICATION.관계인전화번호', { defaultValue: '관계인전화번호' })}</td>
														<td ><input className="form-control w-50" disabled={isDisabled} onChange={handleChangeConcernedPersonPhoneNumber} value={concerned_person_phone_number} /></td>
														<td  className="align-middle">{t('LOAN_APPLICATION.Email', { defaultValue: 'Email' })}</td>
														<td ><input className="form-control w-50" disabled={isDisabled} onChange={handleChangeEmail} value={email}/></td>
													</tr>
													<tr>
														<td  className="align-middle">{t('LOAN_APPLICATION.주소지', { defaultValue: '주소지' })} <span className="text-danger">*</span></td>
														<td ><input className="form-control w-50" disabled={isDisabled} onChange={handleChangeResidencePlace} value={residence_place}/></td>
														<td  className="align-middle">{t('LOAN_APPLICATION.적요 (Remarks)', { defaultValue: '적요 (Remarks)' })}</td>
														<td ><input className="form-control w-50" disabled={isDisabled} onChange={handleChangeRemark} value={remark}/></td>
													</tr>
												</tbody>
											</table>
										</div>					
										<div className="tab-pane fade" id="nav-pills-tab-2" style={fixedTabSizeStyle}>
											<table className="table table-panel mb-0">							
												<tbody>
													<tr>
														<td className="align-middle">{t('LOAN_APPLICATION.배우자 성명', { defaultValue: '배우자 성명' })}</td>
														<td><input className="form-control w-50" disabled={isDisabled} onChange={handleSetSpouseName} value={spouse_name}/></td>
														<td className="align-middle">{t('LOAN_APPLICATION.어머니 성명', { defaultValue: '어머니 성명' })}</td>
														<td><input className="form-control w-50" disabled={isDisabled} onChange={handleSetMotherName} value={mother_name}/></td>
													</tr>
													<tr>
														<td className="align-middle">{t('LOAN_APPLICATION.배우자 전화번호', { defaultValue: '배우자 전화번호' })}</td>
														<td><input className="form-control w-50  text-right" disabled={isDisabled} onChange={handleSetSpousePhoneNumber} value={spouse_phone_number} /></td>
														<td className="align-middle">{t('LOAN_APPLICATION.어머니 전화번호', { defaultValue: '어머니 전화번호' })}</td>
														<td><input className="form-control w-50" disabled={isDisabled} onChange={handleSetMotherPhoneNumber} value={mother_phone_number}/></td>
													</tr>								
													<tr>
														<td className="align-middle">{t('LOAN_APPLICATION.배우자 직업', { defaultValue: '배우자 직업' })}</td>
														<td><input className="form-control w-50" disabled={isDisabled} onChange={handleSetSpouseOccupation} value={spouse_occupation}/></td>
														<td className="align-middle">{t('LOAN_APPLICATION.어머니 직업', { defaultValue: '어머니 직업' })}</td>
														<td><input className="form-control w-50" disabled={isDisabled} onChange={handleSetMotherOccupation} value={mother_occupation}/></td>
													</tr>
													<tr>
														<td className="align-middle">{t('LOAN_APPLICATION.아버지 성명', { defaultValue: '아버지 성명' })}</td>
														<td><input className="form-control w-50" disabled={isDisabled} onChange={handleSetFatherName} value={father_name}/></td>
														<td className="align-middle"></td>
														<td></td>
													</tr>
													<tr>
														<td className="align-middle">{t('LOAN_APPLICATION.아버지 전화번호', { defaultValue: '아버지 전화번호' })}</td>
														<td><input className="form-control w-50" disabled={isDisabled} onChange={handleSetFatherPhoneNumber} value={father_phone_number}/></td>
														<td className="align-middle">{t('LOAN_APPLICATION.기타정보', { defaultValue: '기타정보' })}</td>
														<td><input className="form-control w-50" disabled={isDisabled} onChange={handleSetEtc} value={etc}/></td>
													</tr>
													<tr>
														<td className="align-middle">{t('LOAN_APPLICATION.아버지 직업', { defaultValue: '아버지 직업' })}</td>
														<td><input className="form-control w-50" disabled={isDisabled} onChange={handleSetFatherOccupation} value={father_occupation}/></td>
														<td className="align-middle"></td>
														<td></td>
													</tr>
												</tbody>
											</table>
										</div>					
										<div className="tab-pane fade" id="nav-pills-tab-3" style={fixedTabSizeStyle}>
											<table className="table table-panel mb-0">							
												<tbody>
													<tr>
														<td className="align-middle">{t('LOAN_APPLICATION.관리영업직원', { defaultValue: '관리영업직원' })} <span className="text-danger">*</span></td>
														<td>
															<select className='form-select' value={staffEmail} onChange={(e) => handleChangeStaff(e.target.value)}>
																{responseStaffData.map((option, index) => (
																	<option key={index} value={option.email}>{option.staff_data}</option>
																))}
                                							</select>
														</td>
													</tr>													
												</tbody>
											</table>
										</div>					
									</div>				
								</div>
								<div className = "p-1 pt-4 d-flex justify-content-center">									
									{loan_status === '' || loan_status === 'S01' || loan_status === 'S04' || loan_status === 'S06' ?(<button type="button" className="btn text-white" style={buttonStyleUserSave} onMouseEnter={handleMouseEnterUserSave} onMouseLeave={handleMouseLeaveUserSave} onClick={handleSave}>
											{t(`LOAN_APPLICATION.${buttonText}`, { defaultValue: buttonText })}
										</button>
									) : null}
								</div>
							</div>		
						</Card.Body>
						<Card.Body className='card' style={customCardBodyStyle}>
							
							{/* 대출정보 각종수수료 등 */}
							<div className="">
								<div className="accordion" id="accordion">
									<div className="accordion-item border-0">
										<div className="accordion-header" id="headingOne">
											<button className="accordion-button text-white px-3 py-10px pointer-cursor collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" style={{backgroundColor:'#7DA390'}}>
												<i className="fa fa-circle fa-fw text-blue me-2 fs-8px"></i> {t('LOAN_APPLICATION.대출정보', { defaultValue: '대출정보' })}
											</button>
										</div>
										<Loan002_01 SelectOptions1={SelectOptions1} SelectOptions2={SelectOptions2} SelectOptions3={SelectOptions3} SelectOptions4={SelectOptions4}  SelectOptions5={SelectOptions5} customer_id={customer_id} handleChangeCustomer_id={handleChangeCustomer_id} setLoan_application_id = {setLoan_application_id} loan_application_id = {loan_application_id}  ref={childComponent}/>
									</div>
									<div className="accordion-item border-0">
										<div className="accordion-header" id="headingTwo">
											<button className="accordion-button text-white  px-3 pt-10px pb-10px pointer-cursor collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" style={{backgroundColor:'#7DA390'}}>
												<i className="fa fa-circle fa-fw text-indigo me-2 fs-8px"></i> {t('LOAN_APPLICATION.각종수수료', { defaultValue: '각종수수료' })}</button>
										</div>
										<Loan002_02 loan_application_id={loan_application_id} loan_status={loan_status} />
									</div>
									<div className="accordion-item border-0">
										<div className="accordion-header" id="headingThree">
											<button className="accordion-button text-white px-3 pt-10px pb-10px pointer-cursor collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" style={{backgroundColor:'#7DA390'}}>
												<i className="fa fa-circle fa-fw text-teal me-2 fs-8px"></i> {t('LOAN_APPLICATION.담보물정보', { defaultValue: '담보물정보' })}
											</button>
											
										</div>
										<Loan002_03 loan_application_id = {loan_application_id} loan_status = {loan_status}/>
									</div>
									<div className="accordion-item border-0">
										<div className="accordion-header" id="headingFour">
											<button className="accordion-button text-white  px-3 pt-10px pb-10px pointer-cursor collapsed" style={{backgroundColor:'#7DA390'}} type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour">
												<i className="fa fa-circle fa-fw text-info me-2 fs-8px"></i> {t('LOAN_APPLICATION.추가 첨부파일', { defaultValue: '추가 첨부파일' })}
											</button>
										</div>
										<Loan002_04 loan_application_id = {loan_application_id} loan_status = {loan_status}/>
									</div>					
								</div>
							</div>							
						</Card.Body>
					</div>					
				</div>

				{/* 로딩 관련 gif */}
				{loading && 
					<div
						style={{
							position: 'fixed',
							top: '50%',
							left: '55%',
							transform: 'translate(-50%, -50%)',
							zIndex: 9999,
						}}
					>
						<img src={loader} alt="Loading..." />
					</div>
				}
				
			</Card.Body>

			<div className="card-footer d-flex justify-content-end mt-auto">
				<button type="button" onClick={handleAppModalOpen} className="btn btn-outline-info mb-1 me-1 w-100px">{t('APPROVAL.심사요청', { defaultValue: '심사요청' })}</button>
				{/* <Link to="/loan/loan_001" className="btn btn-outline-success me-1 mb-1 w-100px">
					{t('APPROVAL.취소', { defaultValue: '취소' })}
				</Link> */}
			</div>
			<Loan_002_05 
				showModal={appshowModal}
				setShowModal={setAppShowModal} 
				handleClose={handleAppClose}
				loan_application_id={loan_application_id ? loan_application_id : null}
				loanApplicationId={loanApplicationId ? loanApplicationId : null}
			/>
		<>
		<CustomToast show={toast} setToast={setToast} text={text} />
		</>
		</ Card>
		
	);
};

export default Loan002_standalone;